import React, { useEffect, useState } from "react";
import {
  Tabs,
  Descriptions,
  Skeleton,
  Tag,
  Input,
  message,
} from "antd";
import {
  CopyOutlined,
  HomeOutlined,
  MessageOutlined,
  PieChartOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import Questions from "../conducttest/questions";
import { changeCurrentActiveTestQuestion } from "../../../reducers/trainer";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../common/alert";
import Stats from "./stats";
import Trainee from "./trainee";
import FeedBacks from "./feedbacks";
import "./testdetails.css";

const TestDetails = ({ id }) => {
  const dispatch = useDispatch();
  const { DataActiveTestDetails } = useSelector((state) => state.trainer);

  const [testdetails, setTestDetails] = useState(null);
  const [stats, setStats] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [maxMarks, setMaxMarks] = useState(0);
  const [mainlink, setMainlink] = useState("");
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    const link = window.location.href.split("/").slice(0, 3).join("/") + "/";
    setMainlink(link);

    const p1 = SecurePost({ url: apis.GET_SINGLE_TEST, data: { id } });
    const p2 = SecurePost({ url: apis.GET_STATS, data: { testid: id } });
    const p3 = SecurePost({ url: apis.GET_EXCEL, data: { id } });
    const p4 = SecurePost({ url: apis.MAX_MARKS_FETCH, data: { testid: id } });
    const p5 = SecurePost({ url: apis.GET_FEEDBACKS, data: { testid: id } });

    Promise.all([p1, p2, p3, p4, p5])
      .then((response) => {
        if (response.every((res) => res.data.success)) {
          setTestDetails(response[0].data.data);
          setStats(response[1].data.data);
          setFile(response[2].data.file);
          setMaxMarks(response[3].data.data);
          setFeedbacks(response[4].data.data);
          setLoading(false);
        } else {
          Alert("error", "Error!", response.map((r) => r.data.message).join(" "));
        }
      })
      .catch((error) => {
        const errMsg = error?.response?.data?.message || error.message;
        Alert("error", "Error!", errMsg);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="skeletor-wrapper">
        <Skeleton active />
        <Skeleton active />
      </div>
    );
  }

  const tabItems = [
    {
      key: "1",
      label: (
        <span>
          <HomeOutlined style={{marginRight:6}} />
          Details
        </span>
      ),
      children: (
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="Test Id">
            <Input
            readOnly
              value={id}
              addonAfter={
                <CopyToClipboard
                  text={id}
                  onCopy={() => message.success("Link Copied to clipboard")}
                >
                  <CopyOutlined style={{color:'#1677ff', cursor:'pointer'}}/>
                </CopyToClipboard>
              }
            />
          </Descriptions.Item>
          <Descriptions.Item label="Test Link">
            <Input
            readOnly
              value={`${mainlink}#/user/conducttest?testid=${id}`}
              addonAfter={
                <CopyToClipboard
                  text={`${mainlink}#/user/conducttest?testid=${id}`}
                  onCopy={() => message.success("Link Copied to clipboard")}
                >
                  <CopyOutlined style={{color:'#1677ff', cursor:'pointer'}}/>
                </CopyToClipboard>
              }
            />
          </Descriptions.Item>
          <Descriptions.Item label="Test Name">{testdetails.title}</Descriptions.Item>
          <Descriptions.Item label="Subject">
            {testdetails.subjects.map((tag) => (
              <Tag color="geekblue" key={tag._id}>
                {tag.topic.toUpperCase()}
              </Tag>
            ))}
          </Descriptions.Item>
          <Descriptions.Item label="Created on">
            {moment(testdetails.createdAt).format("DD/ MM/YYYY")}
          </Descriptions.Item>
        </Descriptions>
      ),
    },
    {
      key: "2",
      label: (
        <span>
          <QuestionCircleOutlined style={{marginRight:6}} />
          Questions
        </span>
      ),
      children: (
        <Questions
          id={id}
          questionsOfTest={DataActiveTestDetails.testquestions}
          updateQuestiosnTest={(payload) => dispatch(changeCurrentActiveTestQuestion(payload))}
        />
      ),
    },
    {
      key: "3",
      label: (
        <span>
          <UserOutlined style={{marginRight:6}} />
          Students
        </span>
      ),
      children: <Trainee maxmMarks={maxMarks} id={id} stats={stats} />,
    },
    {
      key: "4",
      label: (
        <span>
          <PieChartOutlined style={{marginRight:6}} />
          Statistics
        </span>
      ),
      children: <Stats id={id} stats={stats} file={file} maxmMarks={maxMarks} />,
    },
    {
      key: "5",
      label: (
        <span>
          <MessageOutlined style={{marginRight:6}}/>
          Feedbacks
        </span>
      ),
      children: <FeedBacks feedbacks={feedbacks} />,
    },
  ];

  return <Tabs defaultActiveKey="1" items={tabItems} className="test-details-tabs" />;
};

export default TestDetails;
